module.exports = __webpack_public_path__ + "static/media/clear.4a5328b4.svg";